import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-behind-square-4, copy 4, layers, pages"} maskId="square-filled-radius-0-stroke-1-IconSquareBehindSquare4"><path fillRule="evenodd" clipRule="evenodd" d="M8 8V2H22V16H16V22H2V8H8ZM15 16H8V9H3V21H15V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareBehindSquare4;
